export const getSingleUseLinkEventTypeAttrs = (eventType) => {
  if (!eventType) return {}

  return {
    eventTypeId: eventType.id,
    eventTypeType: eventType.originalType || eventType.type,
    eventTypeOwnerType: eventType.ownerType || eventType.owner_type,
    eventTypeOwnerId: eventType.ownerId || eventType.owner_id || eventType.profile?.owner_id,
  }
}
